var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7595 10.5328L6.64076 1.67344C6.56447 1.54178 6.43281 1.47656 6.29992 1.47656C6.16703 1.47656 6.03414 1.54178 5.95908 1.67344L0.840331 10.5328C0.688984 10.7961 0.878476 11.1234 1.18117 11.1234H11.4187C11.7214 11.1234 11.9109 10.7961 11.7595 10.5328ZM5.90617 5.11875C5.90617 5.06461 5.95047 5.02031 6.00461 5.02031H6.59523C6.64937 5.02031 6.69367 5.06461 6.69367 5.11875V7.38281C6.69367 7.43695 6.64937 7.48125 6.59523 7.48125H6.00461C5.95047 7.48125 5.90617 7.43695 5.90617 7.38281V5.11875ZM6.29992 9.45C6.14536 9.44684 5.9982 9.38323 5.89001 9.27281C5.78182 9.16239 5.72123 9.01396 5.72123 8.85937C5.72123 8.70479 5.78182 8.55636 5.89001 8.44594C5.9982 8.33552 6.14536 8.2719 6.29992 8.26875C6.45448 8.2719 6.60164 8.33552 6.70983 8.44594C6.81802 8.55636 6.87861 8.70479 6.87861 8.85937C6.87861 9.01396 6.81802 9.16239 6.70983 9.27281C6.60164 9.38323 6.45448 9.44684 6.29992 9.45Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9ab4ed379096635c3723ff86e0c066ea.svg";
export { ForwardRef as ReactComponent };